import { EmptyArray } from 'lib/array/arrayUtils'

/**
 * Resolves the opt-in bundle a room has ticked against the bundles its *current* rate actually
 * offers. State stores only the bundle id, so a tick that no longer matches the rate on screen (a
 * race between a rate refresh and a reducer reset) resolves to nothing rather than to a price the
 * shopper can no longer see.
 *
 * Returns an array because `propertyMultiRoomBuyCallback` takes a list per room, but it holds at
 * most one entry — see `OfferPageState.tickedOptionalBundleIdByRoomId` for that invariant.
 */
export function resolveTickedOptionalBundles(
  rate: App.EnrichedPropertyRate | undefined,
  tickedBundleId: string | undefined,
): Array<App.Property.OptionalBundle> {
  if (!rate || !tickedBundleId) return EmptyArray
  const tickedBundle = rate.optionalBundles.find(optionalBundle => optionalBundle.bundleId === tickedBundleId)
  return tickedBundle ? [tickedBundle] : EmptyArray
}

/** Total a room's ticked bundles add on top of its hotel rate. Display-time only. */
export function getTickedOptionalBundlesPrice(
  rate: App.EnrichedPropertyRate | undefined,
  tickedBundleId: string | undefined,
): number {
  let total = 0
  for (const optionalBundle of resolveTickedOptionalBundles(rate, tickedBundleId)) {
    total += optionalBundle.totalPrice
  }
  return total
}
